"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

import { appAnalyticsConfig } from "@/config/app-analytics-config";
import {
  COOKIE_CONSENT_UPDATED_EVENT,
  getCookieConsent,
} from "@/libs/cookie-consent";

const isProd = process.env.NODE_ENV === "production";

export const Analytics = () => {
  const [hasAnalyticsConsent, setHasAnalyticsConsent] = useState(false);

  useEffect(() => {
    const syncConsent = () => {
      const consent = getCookieConsent();
      setHasAnalyticsConsent(Boolean(consent?.analytics));
    };

    syncConsent();
    window.addEventListener(COOKIE_CONSENT_UPDATED_EVENT, syncConsent);
    return () => window.removeEventListener(COOKIE_CONSENT_UPDATED_EVENT, syncConsent);
  }, []);

  if (!isProd) {
    return null;
  }

  if (isProd && appAnalyticsConfig.googleAnalyticsId && hasAnalyticsConsent) {
    const GoogleAnalytics = dynamic(() => import("./google-analytics"), {
      ssr: false,
    });

    return <GoogleAnalytics />;
  }

  return null;
};
